const getProductPrice = function googleAnalyticsProductPrice(product, isPurchaseEvent) {
  const price = isPurchaseEvent ? product.price : product.rebatePrice || product.price;

  if (price.type) {
    return `${price.min.sales.formatted} - ${price.max.sales.formatted}`;
  }

  return price.sales.value;
};

export default getProductPrice;
